import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    general: {
        site_name: "",
        site_logo_dark: "",
        site_logo_light: "",
        site_favicon: "",
        accent_color: "#fe5b2c",
        primary_color: "#18333b",
        secondary_color: "#67797e",
        is_page_breadcrumbs: true,
        enable_rtl: false,
    },
    sidebar: {
        is_show_logo: true,
        is_show_contact_info: true,
        contact_title: "",
        contact_subtitle: "",
        is_show_subscribe: true,
        is_show_social_media: true,
    },
    footer: {
        footer_is_show_social_media: true,
        footer_is_show_newslatter: true,
        footer_is_show_contact_logo_section: true,
        footer_is_show_useful_links_section: true,
        footer_is_show_service_section: true,
        footer_is_show_resources_section: true,
        copyright_text: "",
    },
    social_links: {
        social_list: [],
    },
    subscriber: {
        subscribe_title: "",
        subscribe_description: "",
    },
    contact: {
        contact_phone_number: "",
        contact_email: "",
        contact_address: "",
    },
    custom_css: "",
    html_embed_code: "",
    original: null,
    isDirty: null  //  تغيير من false إلى null
}

const getCurrentStateObject = (state) => ({
    general: state.general,
    sidebar: state.sidebar,
    footer: state.footer,
    contact: state.contact,
    subscriber: state.subscriber,
    social_links: state.social_links,
    custom_css: state.custom_css,
    html_embed_code: state.html_embed_code
});

const calculateIsDirty = (state) => {
    if (!state.original) return null; //  تغيير من false إلى null
    
    const currentState = getCurrentStateObject(state);
    const currentStateString = JSON.stringify(currentState);
    const originalStateString = JSON.stringify(state.original);
    
    return currentStateString !== originalStateString;
};

const updateIsDirty = (state) => {
    state.isDirty = calculateIsDirty(state);
};

const customizeSlice = createSlice({
    name: "customize",
    initialState,
    reducers: {
        updateGeneral(state, action) {
            state.general = action.payload;
            updateIsDirty(state);
        },
        updateSidebar(state, action) {
            state.sidebar = action.payload;
            updateIsDirty(state);
        },
        updateFooter(state, action) {
            state.footer = action.payload;
            updateIsDirty(state);
        },
        updateContact(state, action) {
            state.contact = action.payload;
            updateIsDirty(state);
        },
        updateSubscribe(state, action) {
            state.subscriber = action.payload;
            updateIsDirty(state);
        },
        updateSocialLink(state, action) {
            state.social_links = action.payload;
            updateIsDirty(state);
        },
        updateCustomCss(state, action) {
            state.custom_css = action.payload;
            updateIsDirty(state);
        },
        updateHtmlEmbedCode(state, action) {
            state.html_embed_code = action.payload;
            updateIsDirty(state);
        },
        resetCustomizeDirty(state) {
            state.isDirty = false; //  بعد إعادة التعيين تصبح false
        },
        setInitialCustomize(state, action) {
            state.original = JSON.parse(JSON.stringify(action.payload));
            state.isDirty = false; //  بعد تعيين original تصبح false
        },
        setDirty(state) {
            state.isDirty = true;
        },
        setClean(state) {
            state.isDirty = false;
        }
    }
});

export const { 
    setInitialCustomize, 
    updateFooter, 
    updateGeneral, 
    updateSidebar, 
    updateContact, 
    updateSubscribe, 
    updateSocialLink, 
    updateCustomCss, 
    updateHtmlEmbedCode,
    resetCustomizeDirty,
    setDirty,
    setClean
} = customizeSlice.actions;

export default customizeSlice.reducer;